<template>
  <div class="kpi-modal">
    <div class="modal fade" data-bs-backdrop="static" :id="'kpiPeriodsModal' + kpi.id" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">
          <div class="modal-header">
            <div class="h5 modal-title text-light">{{ kpi.name }} [{{kpi.unit}}]</div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div class="row justify-content-center mb-4">
              <div class="col-3">
                <label for="filterTimeDim" class="form-label small mb-0">{{ $t("views.kpi.periods.timeDim") }}:</label>
                <select @change="updateFilterFromTo()" v-model="filterTimeDim" id="filterTimeDim" class="form-select form-select-sm fs-09">
                  <option v-if="kpi.timeDimInput === 'M'" value="M">{{ $t("general.month") }}</option>
                  <option v-if="kpi.timeDimInput !== 'Y'" value="Q">{{ $t("general.quarter") }}</option>
                  <option value="Y">{{ $t("general.year") }}</option>
                </select>
              </div>
              <div class="col-3">
                <label for="filterFrom" class="form-label small mb-0">{{ $t("views.kpi.periods.from") }}:</label>
                <select v-model="filterFrom" id="filterFrom" class="form-select form-select-sm">
                  <option v-for="option in filterOptions" :key="'filterFrom' + option" :value="option">{{ formatPeriod(option) }}</option>
                </select>
              </div>
              <div class="col-3">
                <label for="filterTo" class="form-label small mb-0">{{ $t("views.kpi.periods.to") }}:</label>
                <select v-model="filterTo" id="filterTo" class="form-select form-select-sm">
                  <option v-for="option in filterOptions" :key="'filterTo' + option" :value="option">{{ formatPeriod(option) }}</option>
                </select>
              </div>
              <div class="col-3">
                <label class="form-label small mb-0"> {{ $t("views.kpi.periods.available") }}:</label>
                <div class="form-control form-control-sm bg-light">
                  <span v-if="filteredPeriodsReverse?.length > 0"> {{ Math.min(...filterOptions.map(p => Number(p.slice(0, 4)))) }} - {{ Math.max(...filterOptions.map(p => Number(p.slice(0, 4)))) }} </span>
                </div>
               </div>
            </div>
            <div class="row">
              <div class="col">
                <KPIPeriodMultiChart v-if="kpi.records" :key="'kpi-periods-multi' + kpiKeyInt + kpi.id" :chartId="'chartMulti' + kpiKeyInt + kpi.id" :periods="filteredPeriods" class="kpi-chart" style="height: 200px;"></KPIPeriodMultiChart>
              </div>
            </div>
            <div class="row">
              <div v-if="filteredPeriodsReverse?.length > 0">
                <div class="col">
                  <div class="table-kpi-data mt-3">
                    <table class="table table-bordered text-center table-sm table-striped fs-08 mb-0">
                      <thead class="table-primary">
                        <tr>
                          <th scope="col">{{ $t("views.kpi.periods.period") }}</th>
                          <th scope="col">{{ $t("views.kpi.edit.actual") }}</th>
                          <th scope="col">{{ $t("views.kpi.edit.forecast") }}</th>
                          <th scope="col">{{ $t("views.kpi.edit.plan") }}</th>
                          <th scope="col">{{ $t("views.kpi.edit.objective") }}</th>
                          <!-- zur Zeit deaktiviert NICHT LÖSCHEN
                          <th scope="col">
                            <select v-model="selectedDeviation" class="form-select select-th">
                            <option value="actualPlan">{{ $t("views.kpi.periods.devActualPlan") }}</option>
                            <option value="actualObjective">{{ $t("views.kpi.periods.devActualObjective") }}</option>
                            <option value="forecastPlan">{{ $t("views.kpi.periods.devForecastPlan") }}</option>
                            <option value="forecastActual">{{ $t("views.kpi.periods.devForecastActual") }}</option>
                            </select>
                            </th>
                            </td> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="period in filteredPeriodsReverse" :key="kpi.id + period" class="text-end">
                          <th scope="row" class="fw-normal text-center">{{ formatPeriod(period.period) }} </th>
                          <td>{{ isValidNumber(unFormatNumber(period.actual)) ? period.actual : '-' }}</td>
                          <td>{{ isValidNumber(unFormatNumber(period.forecast)) ? period.forecast : '-' }}</td>
                          <td>{{ isValidNumber(unFormatNumber(period.plan)) ? period.plan : '-' }}</td>
                          <td>{{ isValidNumber(unFormatNumber(period.objective)) ? period.objective : '-' }}</td>
                          <!-- zur Zeit deaktiviert NICHT LÖSCHEN
                          <td :class="period.devActualPlan?.includes('+') ? 'text-success' : 'text-danger'">{{ period.devActualPlan ? period.devActualPlan : '-' }}</td>
                          -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-else class="mt-4 text-center bg-secondary text-white">{{ $t("views.kpi.detail.noData") }}</div>
            </div>
          </div>
          <div class="modal-footer bg-light d-flex justify-content-between">
            <div class="fs-08 ms-3">
              <a :href="createLink('kpi', kpi.id)" class="text-decoration-none fs-08" target="_blank">KPI-Definition </a>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KPIPeriodMultiChart from '../charts/KPIPeriodMulti.vue'
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'KPIPeriodsModal',
  props: ['kpi'],
  data () {
    return {
      kpiKeyInt: 0,
      filterTimeDim: this.kpi.timeDimDisplay,
      filterFrom: '',
      filterTo: '',
      filterOptions: '',
      selectedDeviation: 'actualPlan'
    }
  },
  components: {
    KPIPeriodMultiChart
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    filteredPeriods () {
      return this.kpi.records?.filter(record => {
        return record.period.toString().length === this.filterFrom.toString().length &&
               record.period >= this.filterFrom && record.period <= this.filterTo
      })
    },
    filteredPeriodsReverse () {
      return this.kpi.records?.filter(record => {
        return record.period.toString().length === this.filterFrom.toString().length &&
               record.period >= this.filterFrom && record.period <= this.filterTo
      }).reverse()
    },
    actualYear () {
      const actualYear = new Date().getFullYear()
      return actualYear
    }
  },

  methods: {
    updateFilterFromTo () {
      let filterStartYear = ''
      let filterEndYear = ''

      /* Alte Logik (Filterübernahme von ParentForm) NICHT LÖSCHEN, WEIL WIR DAS EVTL. NOCH BRAUCHEN
      if (this.$parent.$parent.filterValidFrom && this.$parent.$parent.filterValidTo) {
        filterStartYear = this.$parent.$parent.filterValidFrom.substr(0, 4)
        filterEndYear = this.$parent.$parent.filterValidTo.substr(0, 4)
      } else if (this.$parent.filterValidFrom && this.$parent.filterValidTo) {
        filterStartYear = this.$parent.filterValidFrom.substr(0, 4)
        filterEndYear = this.$parent.filterValidTo.substr(0, 4)
      } else {
      }
      */

      // Verfügbares Min/Max-Jahr aus FilterOptions bestimmen
      const optionYears = this.filterOptions.map(p => Number(p.slice(0, 4)))
      const minDataYear = Math.min(...optionYears)
      const maxDataYear = Math.max(...optionYears)

      // Aufsetzpunkt ermitteln
      let currentYear = new Date().getFullYear()
      if (maxDataYear < currentYear) currentYear = maxDataYear // Nur Vergangenheitsdaten
      if (minDataYear > currentYear) currentYear = minDataYear // nur Zukunftsdaten

      // Filterwerte Start/Ende setzen (verfügbares Min/Max-Jahr oder Sysparm-Past/FutureYears)
      if (this.filterTimeDim === 'M') {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartMonthPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartMonthFuture)))
        this.filterFrom = filterStartYear + '01'
        this.filterTo = filterEndYear + '12'
      } else if (this.filterTimeDim === 'Q') {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartQuarterPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartQuarterFuture)))
        this.filterFrom = filterStartYear + '1'
        this.filterTo = filterEndYear + '4'
      } else {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartYearPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartYearFuture)))
        this.filterFrom = filterStartYear
        this.filterTo = filterEndYear
      }

      this.kpiKeyInt++
    },

    updateFilterOptions () {
      // Verfügbare Jahre aus den KPI-Records extrahieren
      const years = (this.kpi.records ?? [])
        .map(r => Number(r.period.slice(0, 4)))

      // Kleinstes und größtes Jahr bestimmen (Fallback: aktuelles Jahr)
      const minYear = years.length ? Math.min(...years) : new Date().getFullYear()
      const maxYear = years.length ? Math.max(...years) : new Date().getFullYear()

      // Zeitinkremente abhängig von der Zeitdimension
      const unitsByDim = {
        M: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        Q: ['1', '2', '3', '4'],
        Y: ['']
      }
      const periodsFilterUnits = unitsByDim[this.filterTimeDim] ?? ['']

      // Filteroptionen mit allen Perioden zwischen kleinstem und größtem Jahr generieren
      const filterOptions = []
      for (let year = minYear; year <= maxYear; year++) {
        periodsFilterUnits.forEach(unit => filterOptions.push(year.toString() + unit))
      }

      this.filterOptions = filterOptions
      this.kpiKeyInt++
    },

    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },

    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    },
    isValidNumber (value) {
      return formatUtils.isValidNumber(value)
    }
  },
  watch: {
    kpi: {
      immediate: true,
      handler (newKpi) {
        if (newKpi?.timeDimDisplay) {
          this.filterTimeDim = newKpi.timeDimDisplay
          this.updateFilterOptions()
          this.updateFilterFromTo()
        }
      }
    },
    filterTimeDim () {
      this.updateFilterOptions()
      this.updateFilterFromTo()
    },
    filterFrom () {
      this.kpiKeyInt++
    },
    filterTo () {
      this.kpiKeyInt++
    }
  },
  created () {
    this.updateFilterOptions()
    this.updateFilterFromTo()
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 50vw;
}
.table-kpi-data {
  max-height: 250px;
  overflow-y: scroll;
}
.table-kpi-data table {
  table-layout: fixed;
}
.select-th {
  background-color: transparent;
  border: 0;
  padding: 0 25px 0 0;
  font-weight: bold;
}
</style>
